<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-alert v-if="storeSuccess" dense type="success" outlined text dismissible
                 transition="slide-x-transition" class="py-0 text-uppercase">
          Stock Successfully Added!!!
        </v-alert>
        <v-alert v-for="(item, index) in storeErrors" :key="index" dense type="error" outlined text
                 dismissible transition="slide-x-transition" class="py-0 text-uppercase">
          {{ item[0] }}
        </v-alert>
      </v-col>
      <v-col cols="4">
        <v-autocomplete v-model="stockCode" :search-input.sync="stockSearchInput" label="Product Code"
                        :items="computedStockList" item-value="id" no-filter :loading="stockLoading">
          <template v-slot:selection="{ item }">
            {{ item.stock_code }}
          </template>
          <template v-slot:item="{ item }">
            <span class="blue--text">{{ item.stock_code }}</span>
            <span class="mx-1" />
            <small>{{ item.product_name }} ({{ item.brand_name }})</small>
          </template>
        </v-autocomplete>
      </v-col>
      <v-col cols="8" align-self="end">
        <v-text-field label="Product Name" :value="productName" disabled />
      </v-col>
      <v-col cols="6" align-self="end">
        <v-text-field label="Brand" :value="brandName" disabled />
      </v-col>
      <v-col cols="6" align-self="end">
        <v-text-field v-model="cost" label="Cost" required :suffix="`/ ${unit}`" prefix="₱"
                      type="number" />
      </v-col>
      <v-col cols="6">
        <v-btn color="green" @click="initStore">
          Add
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import stockRepository from '@/repositories/stock.repository'
import { apiVars } from '@/extra-functions/api-helper.extra'
import searchDelay from '@/extra-functions/searchDelay.extra'
import { errorHandler } from '@/extra-functions/store.extra'

const delayedSearch = searchDelay(1000)

function inputVars() {
  return {
    stockCode: null,
    stockSearchInput: null,
    brandName: null,
    unit: null,
    retail: null,
    productName: null,
    cost: null,
  }
}

export default {
  name: 'VCreateSupplierProduct',
  props: {
    propSupplierId: {
      type: String,
      default: '',
    },
    propSupplierProducts: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      ...apiVars('stock'),
      ...inputVars(),
    }
  },
  mounted() {
    this.searchStocks()
  },
  computed: {
    ...mapState({
      // stocks: state => state.stock.list,
      storeSuccess: state => state.supplierProduct.storeSuccess,
      stockUdated: state => state.stock.channelUpdated,
      storeErrors: state => state.supplierProduct.storeErrors,
      // supplierProducts: state => state.supplierProduct.list,
      storeId: state => state.settings.storeId,
    }),
    computedStockList() {
      const stockIds = this.propSupplierProducts.map(obj => obj.stock_id)
      const supplierProducts = new Set(stockIds)
      return this.stockList.filter(e => !supplierProducts.has(e.id))
    },
  },
  watch: {
    stockUpdated() {
      this.stockLoading = true
      delayedSearch(() => { this.searchStocks() })
    },
    stockSearchInput() {
      this.stockLoading = true
      delayedSearch(() => { this.searchStocks() })
    },
    stockCode(val) {
      const data = this.getStockInfo(val)
      this.brandName = data.brand_name
      this.description = data.description
      this.retail = data.retail
      this.productName = data.product_name
      this.unit = data.unit
    },
  },
  methods: {
    ...mapActions({
      store: 'supplierProduct/store',
    }),
    initStore() {
      const data = {
        store_id: this.storeId,
        stock_id: this.stockCode,
        supplier_id: this.propSupplierId,
        cost: this.cost,
        unit: this.unit,
      }
      this.store(data)
    },
    searchStocks() {
      stockRepository.storeList(this.storeId, { index: 0, limit: 0, search: this.stockSearchInput })
        .then(({ data }) => { this.stockList = data })
        .catch(e => { this.stockErrors = errorHandler(e) })
        .then(() => { this.stockLoading = false })
    },
    getStockInfo(val) {
      return this.stockList.find(e => {
        return e.id === val
      })
    },
  },
}
</script>
